import { render, staticRenderFns } from "./ThreeLess.vue?vue&type=template&id=898cc606&scoped=true"
import script from "./ThreeLess.vue?vue&type=script&lang=js"
export * from "./ThreeLess.vue?vue&type=script&lang=js"
import style0 from "./ThreeLess.vue?vue&type=style&index=0&id=898cc606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898cc606",
  null
  
)

export default component.exports